import dateFormatType from '@/constants/dateFormatType';
import { timezoneOffsetMillis } from '@/constants/global';
import { currency, formatDate, } from '@/utils';
export default {
    transactionAt: (state) => formatDate(state.data.transactionAt + timezoneOffsetMillis, dateFormatType.FULL_DATE),
    transactionBaromoney: (state) => currency(state.data.transactionBaromoney),
    virtualBankAccount: (state) => state.virtualBank.account,
    virtualBankName: (state) => state.virtualBank.bankName,
};
